var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5536 10.5151C10.5901 10.4592 10.6143 10.4004 10.6569 10.3621C11.7286 9.32344 12.8033 8.28474 13.875 7.24899C14.0572 7.07244 14.2697 6.99888 14.5217 7.06656C14.7676 7.13129 14.9225 7.28724 14.9802 7.52558C15.0409 7.76392 14.9589 7.96401 14.7798 8.13468C14.2515 8.64373 13.7232 9.15572 13.195 9.66477C12.4785 10.3563 11.762 11.0507 11.0455 11.7422C10.6902 12.0864 10.3381 12.0864 9.97982 11.7392C8.73808 10.5387 7.49027 9.33815 6.25157 8.12879C6.14227 8.01992 6.04816 7.86691 6.01476 7.71979C5.951 7.44908 6.09977 7.19897 6.34569 7.07244C6.58857 6.94886 6.88307 6.98417 7.08952 7.17249C7.25043 7.31961 7.40526 7.47556 7.56314 7.62563C8.50734 8.54074 9.45155 9.45585 10.3958 10.368C10.4322 10.4063 10.4717 10.4416 10.5536 10.5151Z",
    fill: "#011367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.a8ecaf3e647c39a4a2d0973f29878964.svg";
export { ForwardRef as ReactComponent };